// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// A tab signed out by another tab reloads onto the sign-in page, which then says why. The note crosses the reload
// in the tab's own sessionStorage and is shown once.
const SIGNED_OUT_NOTICE_KEY = 'signedOutInOtherTab';

export const SIGNED_OUT_IN_OTHER_TAB = 'You were signed out in another tab';

export const rememberSignedOutNotice = () => {
  try {
    sessionStorage.setItem(SIGNED_OUT_NOTICE_KEY, 'true');
  } catch {
    // A tab whose storage refuses signs out without the note
  }
};

export const readSignedOutNotice = () => {
  try {
    return sessionStorage.getItem(SIGNED_OUT_NOTICE_KEY) ? SIGNED_OUT_IN_OTHER_TAB : null;
  } catch {
    return null;
  }
};

export const forgetSignedOutNotice = () => {
  try {
    sessionStorage.removeItem(SIGNED_OUT_NOTICE_KEY);
  } catch {
    // Nothing was remembered
  }
};
